var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.99935 12.8339C10.221 12.8339 12.8327 10.2222 12.8327 7.00057C12.8327 3.77891 10.221 1.16724 6.99935 1.16724C3.77769 1.16724 1.16602 3.77891 1.16602 7.00057C1.16602 10.2222 3.77769 12.8339 6.99935 12.8339Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61732 7.00033L8.95898 5.65866C9.12815 5.48949 9.12815 5.20949 8.95898 5.04033C8.78982 4.87116 8.50982 4.87116 8.34065 5.04033L6.99898 6.38199L5.65732 5.04033C5.48815 4.87116 5.20815 4.87116 5.03898 5.04033C4.86982 5.20949 4.86982 5.48949 5.03898 5.65866L6.38065 7.00033L5.03898 8.34199C4.86982 8.51116 4.86982 8.79116 5.03898 8.96033C5.12648 9.04783 5.23732 9.08866 5.34815 9.08866C5.45898 9.08866 5.56982 9.04783 5.65732 8.96033L6.99898 7.61866L8.34065 8.96033C8.42815 9.04783 8.53898 9.08866 8.64982 9.08866C8.76065 9.08866 8.87148 9.04783 8.95898 8.96033C9.12815 8.79116 9.12815 8.51116 8.95898 8.34199L7.61732 7.00033Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.2c050ec63f5c932d6270b120a2cd2293.svg";
export { ForwardRef as ReactComponent };